import { OcpsPolicy } from './OcpsPolicy';
import {
    USER_OCPS_EMAIL_COLLECTION_ENABLED,
    USER_OCPS_LOG_CONTENT_ENABLED,
    USER_OCPS_FEEDBACK_ENABLED,
    USER_OCPS_NPS_SURVEY_ENABLED,
    USER_OCPS_OUTLOOK_RECOMMENDATION_ENABLED,
    USER_OCPS_SCREENSHOT_ENABLED,
} from 'owa-ocps-get-policies/lib/utils/constants';

export function getOcpsPolicyName(policyName: OcpsPolicy): string {
    switch (policyName) {
        case OcpsPolicy.Contact:
            return USER_OCPS_EMAIL_COLLECTION_ENABLED;
        case OcpsPolicy.Content:
            return USER_OCPS_LOG_CONTENT_ENABLED;
        case OcpsPolicy.Feedback:
            return USER_OCPS_FEEDBACK_ENABLED;
        case OcpsPolicy.NpsSurvey:
            return USER_OCPS_NPS_SURVEY_ENABLED;
        case OcpsPolicy.OutlookRecommendation:
            return USER_OCPS_OUTLOOK_RECOMMENDATION_ENABLED;
        case OcpsPolicy.ScreenShot:
            return USER_OCPS_SCREENSHOT_ENABLED;

        default:
            return '';
    }
}
